export enum ToursEnum {
  REGISTER_PATIENT = 'registerPatient', // Registrar paciente
  REGISTER_FOOD_DISH = 'registerFoodDish', // Registrar platillo
  REGISTER_MEAL_PLAN = 'registerMealPlan', // Registrar plan de alimentación
  REGISTER_BRANCH = 'registerBranch', // Registrar sucursal
  CHECK_SCHEDULE = 'checkSchedule', // Agenda
  SCHEDULE_APPOINTMENT = 'scheduleAppointment', // Agendar cita
  SPHERE = 'sphere', // Esfera
  SCHEDULES = 'schedules', // Grupos de horarios
  EXPERT_SCHEDULES = 'expertSchedules', // Grupos de horarios solo como experto
  ADVICE = 'advice', // Asesorías
// Cuando se completan todos los tours esta variable es boolean, pero cuando se inicia un tour es un string
  FORCE_TOUR_NAME = 'forceTourName',

  // Local tours
  ASSIGN_MEAL_PLAN = 'assignMealPlan', // Se ocupa como bandera para explicar la lista de planes de alimentación que están asignados al paciente
  ASSIGN_CREATE_MEAL_PLAN = 'assignCreateMealPlan', // Crea un plan de alimentación desde cero y lo asigna a un paciente
  ASSIGN_SELECT_MEAL_PLAN = 'assignSelectMealPlan', // Selecciona un plan de alimentación y lo asigna a un paciente
  // Cuando se completan todos los tours esta variable es boolean, pero cuando se inicia un tour es un string

}


